import { Component, OnInit } from '@angular/core';
import { MainService } from '../../services/main.service';

@Component({
  selector: 'app-building-imgs',
  templateUrl: './building-imgs.component.html',
  styleUrls: ['./building-imgs.component.scss']
})
export class BuildingImgsComponent implements OnInit {

  pageData: any = {};

  constructor(private api: MainService) { }

  loadData() {

    this.api.getMediaBuildList().subscribe(
      data => {
        //debugger
        console.log(data);
        this.pageData = data;
      }, error => {
        console.log(error);
      });
  }
  ngOnInit() {

    this.loadData();
    window.scrollTo(0, 0);
  }

}
